import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { FlowComponentType } from 'routes/types';

import Button, { ButtonType } from 'components/Button';
import FormNavigation, { FormNavigationProps } from 'components/FormNavigation';
import FormContainer from 'components/LoanForm/FormContainer';
import DecisionButtons, { DecisionOptions } from 'components/SetupDeduction/ManualDeduction/components/DecisionButtons';
import { RepaymentDecisionResult } from 'enums/FlowNextResults';
import { getApplicationData } from 'selectors/getApplicationData';

import { ReactComponent as ProfileIcon } from 'images/profile-icon.svg';

import styles from './PaystubsSignInGuide.module.scss';

interface PaystubsSignInGuideProps extends FlowComponentType {
  NavigationComponent?: FC<FormNavigationProps>;
}

const PaystubsSignInGuide = ({
  navigationInfo,
  handleNext,
  NavigationComponent = FormNavigation,
}: PaystubsSignInGuideProps) => {
  const { employment } = useSelector(getApplicationData).application ?? {};
  const employerPortalDataInstructions = employment?.employer1.employerPortalData;
  const knowEmployer = employerPortalDataInstructions?.portalURL;

  const handleContinue = (decision: DecisionOptions) => {
    handleNext(decision === DecisionOptions.No ? RepaymentDecisionResult.No : undefined);
  };

  const handleSignIn = () => {
    window.open(employerPortalDataInstructions?.portalURL, '_blank');
  };

  return (
    <>
      <NavigationComponent {...navigationInfo} />
      <FormContainer title="Sign in where you access paystubs online.">
        <div className={styles.mainContainer}>
          <p>
            Use your work credentials to sign in
            {knowEmployer ? (
              <>
                {' '}
                to <span>{employment?.employer1?.employerName}</span>.
              </>
            ) : (
              '.'
            )}
          </p>
          {knowEmployer && (
            <Button type={ButtonType.Inverted} className={styles.signInButton} onClick={handleSignIn}>
              <ProfileIcon />
              Sign in
            </Button>
          )}
        </div>
        <DecisionButtons handleContinue={handleContinue} title="Are you able to sign in?" />
      </FormContainer>
    </>
  );
};

export default PaystubsSignInGuide;
